<!-- <div hidden>
<input type="file" id="fileUpload" (change)="selectFile($event)" accept=".xlsx">
</div> -->

<mat-toolbar class="custom-toolbar">
  <mat-toolbar-row class="mat-elevation-z6" style="height:5px;" />
  <mat-toolbar-row class="mat-elevation-z6">
    <span><a href='javascript:void(0)' (click)="refreshData()" style="text-decoration: none;">Calendar</a></span>
    <span class="example-spacer"></span>

    <div class="example-button-row">
      @if (this.supplierId) {
        <button mat-raised-button color="primary" (click)="openAddDialog()">
          <mat-icon>add</mat-icon> Add
        </button>
      }
      <button mat-raised-button color="primary" (click)="export()">
        <mat-icon>cloud_download</mat-icon> Export
      </button>
      <!-- <button *ngIf="true" mat-raised-button color="primary" (click)="showSelectFileDialog()">
      <mat-icon>cloud_upload</mat-icon> Upload
    </button> -->
  </div>

</mat-toolbar-row>
<mat-toolbar-row class="mat-elevation-z6" style="height:5px;" />
</mat-toolbar>

<app-my-loader />


<mat-card>
  <table class="main-table">
    <tr>
      <td class="calendar">
        <div class="calendar-container">
          <table class="calendar-header">
            <tr>
              <td>
                <button mat-button class="prev-year" (click)="prevYear()"><mat-icon class="button-bar-icon">keyboard_double_arrow_left</mat-icon></button>
                <button mat-button class="prev-month" (click)="prevMonth()"><mat-icon class="button-bar-icon">keyboard_arrow_left</mat-icon></button>
              </td>
              <td>
                <mat-form-field class='calendar-select-field' style="margin-right: 10px;">
                  <mat-select [(ngModel)]="this.month" class="calendar-select" style="padding-right: 5px;" (selectionChange)="refreshData()">
                    @for (m of months; track m) {
                      <mat-option [value]="m.id">
                        {{m.name}}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>

                <mat-form-field class='calendar-select-field'>
                  <mat-select [(ngModel)]="this.year" class="calendar-select" (selectionChange)="refreshData()">
                    @for (y of years; track y) {
                      <mat-option [value]="y">
                        {{y}}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </td>
              <td>
                <button mat-button class="next-month" (click)="nextMonth()"><mat-icon class="button-bar-icon">keyboard_arrow_right</mat-icon></button>
                <button mat-button class="next-year" (click)="nextYear()"><mat-icon class="button-bar-icon">keyboard_double_arrow_right</mat-icon></button>
              </td>
            </tr>
          </table>

          <table class="calendar-month">
            <tr class="days-of-week">
              <td>MON</td>
              <td>TUE</td>
              <td>WED</td>
              <td>THU</td>
              <td>FRI</td>
              <td>SAT</td>
              <td>SUN</td>
            </tr>
            @for (w of calendar; track w) {
              <tr class="calendar-week">
                @for (d of w.weekdays; track d) {
                  <td class="calendar-day" [class]="d.status">
                    <button mat-button (click)="onCalendarDayClick(w.week, d.date, d.type)" [disabled]="d.status==='disabled'">
                                    <div class="day-type" [class]="'day-type-' + d.type"
                                        [class.day-type-hidden]="(d.type === 'nodelivery' && !this.showdelivery)
                                            || (d.type === 'noproduction' && !this.showproduction)
                                            || (d.type === 'noproductionanddelivery' && !this.showproductionanddelivery)"></div>
                      <div class='day-of-the-month'>
                        {{d.date.split('-')[2][0] == '0' ? d.date.split('-')[2][1] : d.date.split('-')[2]}}
                      </div>
                      <div class='day-of-the-week'>
                        @switch (d.day) {
                          @case (1) {
                            <span>monday</span>
                          }
                          @case (2) {
                            <span>tuesday</span>
                          }
                          @case (3) {
                            <span>wednesday</span>
                          }
                          @case (4) {
                            <span>thursday</span>
                          }
                          @case (5) {
                            <span>friday</span>
                          }
                          @case (6) {
                            <span>saturday</span>
                          }
                          @case (7) {
                            <span>sunday</span>
                          }
                        }
                      </div>
                    </button>
                  </td>
                }
              </tr>
            }
          </table>
        </div>
      </td>
      <td class="side-container">
        <lf-select-search [listElements]="suppliers" placeholder="GA Supplier (No. / Name)" placeholderLabel="search supplier" (selected)="supplierChanged($event)" [selectedElementId]="supplierSelected" showClose="false" />


        <div class="calendar-legend">
          <mat-label class="calendar-label">Legend:</mat-label><br>
          <ul>
            <li (click)="showHideDelivery()" [class.legend-hidden]="!this.showdelivery"><div class="legend-day-type day-type-nodelivery"></div>{{ legend['nodelivery'] }}</li>
            <li (click)="showHideProduction()" [class.legend-hidden]="!this.showproduction"><div class="legend-day-type day-type-noproduction"></div>{{ legend['noproduction'] }}</li>
            <li (click)="showHideProductionAndDelivery()" [class.legend-hidden]="!this.showproductionanddelivery"><div class="legend-day-type day-type-noproductionanddelivery"></div>{{ legend['noproductionanddelivery'] }}</li>
          </ul>
        </div>

        @if (this.supplierId && this.series && this.series.length>0) {
          <div class="calendar-series">
            <mat-label class="calendar-label">Calendar series:</mat-label><br>
            <div class="series-list">
              @for (s of series; track s) {
                <button mat-stroked-button class="series-btn"
                  (contextmenu)="seriesClick($event, s.id)"
                  title="{{ legend[s.type] + '\nRight click to delete' }}">
                  <div class="series-color" [class]="'day-type-' + s.type"></div>
                  <span
                  class='series-name' title="{{s.description}}">{{s.description}}</span>
                </button>
                <br>
                }
              </div>
            </div>
          }
        </td>
      </tr>
    </table>

  </mat-card>
